import { render } from "./cadastro_seguro.vue?vue&type=template&id=47de7448&scoped=true"
import script from "./cadastro_seguro.vue?vue&type=script&lang=js"
export * from "./cadastro_seguro.vue?vue&type=script&lang=js"

import "./cadastro_seguro.vue?vue&type=style&index=0&id=47de7448&scoped=true&lang=css"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47de7448"]])

export default __exports__